import { toTimestamp } from 'common/utils';
import { differenceInMinutes } from 'date-fns';
import { EventRoom, EventRoomApiPayload } from 'domain/event';
import { BackstageRoomApiPayload } from 'store/apis/event';

import { mapToEventRoomAttendeeFromApi } from './mapToEventRoomAttendeeFromApi';

export const mapEventRoomFromApi = (room: EventRoomApiPayload): EventRoom => {
  const { agoraToken, startTime: apiStartTime, endTime: apiEndTime, id, attendees = [] } = room;
  const startTime = toTimestamp(apiStartTime);
  const endTime = toTimestamp(apiEndTime);
  // `startTime` can be absent on the room_opened payload (it's replayed later — see
  // mapBackstageRoomFromApi), in which case `toTimestamp` yields NaN. Guard so we never emit a NaN
  // duration that downstream consumers (e.g. RoomCounter's clamp) would choke on (HNS-147).
  const duration =
    Number.isFinite(startTime) && Number.isFinite(endTime)
      ? differenceInMinutes(endTime, startTime, { roundingMethod: 'round' })
      : undefined;

  return {
    id,
    accessToken: agoraToken,
    attendees: attendees.map(mapToEventRoomAttendeeFromApi),
    duration,
    endTime,
    startTime,
    orderNumber: -1,
    roomQuestionAssignments: room.roomQuestionAssignments ?? [],
  };
};

// The Backstage snapshot only carries id, endTime, and attendees — agoraToken, startTime, and
// roomQuestionAssignments are delivered later via the room_opened WS replay on JoinMeetingCommand.
export const mapBackstageRoomFromApi = (room: BackstageRoomApiPayload): EventRoom => ({
  id: room.id,
  startTime: 0,
  endTime: toTimestamp(room.endTime),
  duration: 0,
  attendees: room.attendees.map(mapToEventRoomAttendeeFromApi),
  orderNumber: -1,
  roomQuestionAssignments: [],
});
